var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSort(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1174 6.42187C12.1696 6.3701 12.2108 6.30836 12.2387 6.24033C12.2812 6.13788 12.2924 6.02512 12.2708 5.91631C12.2492 5.80751 12.1958 5.70756 12.1174 5.62911L8.15362 1.66533C8.0485 1.56021 7.90591 1.50115 7.75724 1.50115C7.60857 1.50115 7.46599 1.56021 7.36087 1.66533L3.39709 5.62911C3.31845 5.70747 3.26485 5.80742 3.24308 5.91627C3.22131 6.02513 3.23235 6.13801 3.27481 6.24058C3.31726 6.34316 3.38922 6.43082 3.48156 6.49245C3.57389 6.55408 3.68245 6.5869 3.79347 6.58676L11.721 6.58676C11.7947 6.58667 11.8676 6.57206 11.9356 6.54376C12.0036 6.51547 12.0654 6.47405 12.1174 6.42187Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.27525 9.83086C3.23272 9.93331 3.22155 10.0461 3.24314 10.1549C3.26473 10.2637 3.31812 10.3636 3.39654 10.4421L7.36032 14.4059C7.46544 14.511 7.60803 14.57 7.7567 14.57C7.90537 14.57 8.04795 14.511 8.15307 14.4059L12.1169 10.4421C12.1955 10.3637 12.2491 10.2638 12.2709 10.1549C12.2926 10.0461 12.2816 9.93318 12.2391 9.8306C12.1967 9.72803 12.1247 9.64037 12.0324 9.57874C11.94 9.51711 11.8315 9.48428 11.7205 9.48442L3.79292 9.48442C3.68204 9.4845 3.57368 9.51745 3.48154 9.57912C3.38939 9.64078 3.3176 9.72839 3.27525 9.83086Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort);
export default __webpack_public_path__ + "static/media/sort.c1fdce10.svg";
export { ForwardRef as ReactComponent };